const setPosHash = () => {
  const id = location.hash;

  if (!id) return;
  const target = document.querySelector(id);

  const adjust = 20;

  const pageHeader = document.getElementById('page-header');

  const scrollPos = target.getBoundingClientRect().top - pageHeader.clientHeight - adjust;

  const scrollTop = document.documentElement.scrollTop;


  window.scrollTo(
    0,
    scrollTop + scrollPos
  );

};

const init = () => {
  setPosHash();
};

export default init;
